import { Component, OnInit, ViewContainerRef, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { Response } from '@angular/http';
import { NgForm, FormGroup, FormArray, FormControl, Validators, FormBuilder  } from '@angular/forms';
import { ServicesDeliveryService } from '../../services/services-delivery.service';
import {DialogSharedComponent} from '../dialog-shared/dialog-shared.component';
import {MatDialog} from '@angular/material';

@Component({
  selector: 'app-services-delivery',
  templateUrl: './services-delivery.component.html',
  providers: [ServicesDeliveryService]
})
export class AdminServicesDeliveryComponent implements OnInit, AfterViewInit {

    servicesForm: FormGroup;
    services: any;
  serviceProviders = [{value: '', label: ''}];
    submittedService = false;
    logged = false;
    serviceNum = 0;
    config: any;
    constructor(private _fb: FormBuilder, private servicesDeliveryService: ServicesDeliveryService, public dialog: MatDialog) {}


    ngOnInit() {
        this.servicesForm = this._fb.group({
            services: this._fb.group({
                services: ['', Validators.required]
            }),
            serviceInfo: this._fb.group({
                configs: this._fb.array([
                    this.initServiceConfig()
                ]),
                image: [''],
                active: ['']
            })
        });

        this.servicesForm.controls['services'].valueChanges.subscribe(
            (data: any) => this.changeService()
        );

        this.servicesDeliveryService.getServices().subscribe((res) => {
            this.services = res.data;
            if (res.data[0] && typeof(res.data[0]) != 'undefined') {
                this.config = res.data[0].config;
                const getServData = [];
                for (const key in this.services) {
                    getServData.push({value: key, label: this.services[key].name});
                }
                this.logged = true;
                this.serviceProviders = getServData;
                this.servicesForm.controls['services']['controls'].services.setValue('0');
            }
        });
    }

    initServiceConfig() {
        return this._fb.group({
            keyword:   [{value: '', disabled: true}],
            value:     ['', Validators.required],
            id:   ['']
        });
    }


    addServiceConfig(data) {
        for (const key in data) {
            const control = (<FormArray>(<FormGroup>this.servicesForm.controls['serviceInfo']).controls['configs']);
            const count_parcel = this.servicesForm.controls['serviceInfo']['controls'].configs.controls.length - 1;
            control.push(this.initServiceConfig());
            const config_new = this.servicesForm.controls['serviceInfo']['controls'].configs.controls[count_parcel + 1];
            config_new['controls'].value.setValue(data[key].value);
            config_new['controls'].keyword.setValue(data[key].keyword);
            config_new['controls'].id.setValue(data[key].id);
        }
    }

    removeServiceConfig(data) {
        for (const key in data) {
            const control = (<FormArray>(<FormGroup>this.servicesForm.controls['serviceInfo']).controls['configs']);
            control.removeAt(0);
        }
    }

    ngAfterViewInit() {
      //  $(this.dropdown.nativeElement).material_select();
    }
    changeService() {
        const service = this.servicesForm.controls['services'].value.services;
        this.serviceNum = service;
        this.removeServiceConfig(this.config);
        this.config = this.services[service].config;
        this.addServiceConfig(this.config);
        this.servicesForm.controls['serviceInfo']['controls'].image.setValue(this.services[this.serviceNum].image);
        this.servicesForm.controls['serviceInfo']['controls'].active.setValue(this.services[this.serviceNum].active);
    }

   save() {
        this.submittedService = true;
        const configs = [];
        const controls = this.servicesForm.controls['serviceInfo']['controls'].configs;
        for (const key in controls.controls) {
            if (controls.controls[key].valid) {
                configs.push({
                    'id': controls.controls[key]['controls'].id.value,
                    'value_data': controls.controls[key]['controls'].value.value,
                    'keyword': controls.controls[key]['controls'].keyword.value
                });
            }
        }
        const data = {
            serviceInfo: {
               'id': this.services[this.serviceNum].id,
               'name': this.services[this.serviceNum].name,
               'image': this.servicesForm.controls['serviceInfo']['controls'].image.value,
               'active': this.servicesForm.controls['serviceInfo']['controls'].active.value
            },
            configs: configs
        };
        this.servicesDeliveryService.setService(this.services[this.serviceNum].id, data).subscribe((data) => {
          const dialogRef = this.dialog.open(DialogSharedComponent,
            {width: '450px', data: { errorType: 'null', header: 'service.success' }});
        });
   }
}



// WEBPACK FOOTER //
// ./src/app/components/services-delivery/services-delivery.component.ts